module.exports = __webpack_public_path__ + "static/rcc-image-desktop-21f200951707f70093e618ca926ff7ef.png";